import { useCallback } from 'react';
import { observer } from 'mobx-react';

import { CancelRoot } from './Cancel.Root';
import { Store } from '../../../../stores';

const CancelComponent = () => {
  const store = Store.use();

  const cancel = useCallback(async () => {
    await store.cancelCode();
  }, [store]);

  return (
    <CancelRoot type="button" variant="plain" onClick={cancel}>
      Отмена
    </CancelRoot>
  );
};

export const Cancel = observer(CancelComponent);
